export interface DefaultCategory {
  name: string;
  icon: string;
  color: string;
  type: 'income' | 'expense';
  subcategories?: { name: string; icon: string }[];
}

export const DEFAULT_EXPENSE_CATEGORIES: DefaultCategory[] = [
  {
    name: 'Food & Dining',
    icon: 'Utensils',
    color: '#f97316',
    type: 'expense',
    subcategories: [
      { name: 'Groceries', icon: 'ShoppingCart' },
      { name: 'Restaurants', icon: 'UtensilsCrossed' },
      { name: 'Coffee & Snacks', icon: 'Coffee' }
    ]
  },
  {
    name: 'Transportation',
    icon: 'Car',
    color: '#3b82f6',
    type: 'expense',
    subcategories: [
      { name: 'Fuel', icon: 'Fuel' },
      { name: 'Public Transit', icon: 'Bus' },
      { name: 'Ride Share', icon: 'CarTaxiFront' },
      { name: 'Parking', icon: 'ParkingCircle' }
    ]
  },
  {
    name: 'Housing',
    icon: 'Home',
    color: '#8b5cf6',
    type: 'expense',
    subcategories: [
      { name: 'Rent', icon: 'Key' },
      { name: 'Utilities', icon: 'Zap' },
      { name: 'Maintenance', icon: 'Wrench' },
      { name: 'Insurance', icon: 'Shield' }
    ]
  },
  {
    name: 'Shopping',
    icon: 'ShoppingBag',
    color: '#ec4899',
    type: 'expense',
    subcategories: [
      { name: 'Clothing', icon: 'Shirt' },
      { name: 'Electronics', icon: 'Smartphone' },
      { name: 'Home Goods', icon: 'Lamp' }
    ]
  },
  {
    name: 'Entertainment',
    icon: 'Film',
    color: '#14b8a6',
    type: 'expense',
    subcategories: [
      { name: 'Movies & TV', icon: 'Tv' },
      { name: 'Games', icon: 'Gamepad2' },
      { name: 'Events', icon: 'Ticket' },
      { name: 'Subscriptions', icon: 'CreditCard' }
    ]
  },
  {
    name: 'Health',
    icon: 'Heart',
    color: '#ef4444',
    type: 'expense',
    subcategories: [
      { name: 'Medical', icon: 'Stethoscope' },
      { name: 'Pharmacy', icon: 'Pill' },
      { name: 'Fitness', icon: 'Dumbbell' }
    ]
  },
  {
    name: 'Education',
    icon: 'GraduationCap',
    color: '#6366f1',
    type: 'expense',
    subcategories: [
      { name: 'Courses', icon: 'BookOpen' },
      { name: 'Books', icon: 'Book' },
      { name: 'Supplies', icon: 'Pencil' }
    ]
  },
  {
    name: 'Personal Care',
    icon: 'Sparkles',
    color: '#f472b6',
    type: 'expense'
  },
  {
    name: 'Gifts & Donations',
    icon: 'Gift',
    color: '#a855f7',
    type: 'expense'
  },
  {
    name: 'Travel',
    icon: 'Plane',
    color: '#0ea5e9',
    type: 'expense',
    subcategories: [
      { name: 'Flights', icon: 'PlaneTakeoff' },
      { name: 'Hotels', icon: 'Hotel' },
      { name: 'Activities', icon: 'MapPin' }
    ]
  },
  {
    name: 'Bills & Fees',
    icon: 'Receipt',
    color: '#64748b',
    type: 'expense',
    subcategories: [
      { name: 'Phone', icon: 'Phone' },
      { name: 'Internet', icon: 'Wifi' },
      { name: 'Bank Fees', icon: 'Building2' }
    ]
  },
  {
    name: 'Other',
    icon: 'MoreHorizontal',
    color: '#94a3b8',
    type: 'expense'
  }
];

export const DEFAULT_INCOME_CATEGORIES: DefaultCategory[] = [
  {
    name: 'Salary',
    icon: 'Briefcase',
    color: '#22c55e',
    type: 'income'
  },
  {
    name: 'Freelance',
    icon: 'Laptop',
    color: '#10b981',
    type: 'income'
  },
  {
    name: 'Business',
    icon: 'Building',
    color: '#059669',
    type: 'income'
  },
  {
    name: 'Investments',
    icon: 'TrendingUp',
    color: '#14b8a6',
    type: 'income'
  },
  {
    name: 'Gifts Received',
    icon: 'Gift',
    color: '#f472b6',
    type: 'income'
  },
  {
    name: 'Refunds',
    icon: 'RotateCcw',
    color: '#6366f1',
    type: 'income'
  },
  {
    name: 'Other Income',
    icon: 'Plus',
    color: '#94a3b8',
    type: 'income'
  }
];

export const ALL_DEFAULT_CATEGORIES = [
  ...DEFAULT_EXPENSE_CATEGORIES,
  ...DEFAULT_INCOME_CATEGORIES
];

export const ACCOUNT_TYPE_OPTIONS = [
  { value: 'checking', label: 'Checking Account', icon: 'Building2' },
  { value: 'savings', label: 'Savings Account', icon: 'PiggyBank' },
  { value: 'cash', label: 'Cash', icon: 'Wallet' },
  { value: 'credit_card', label: 'Credit Card', icon: 'CreditCard' },
  { value: 'other', label: 'Other', icon: 'MoreHorizontal' }
] as const;

export const ACCOUNT_COLORS = [
  '#3b82f6',
  '#22c55e',
  '#ef4444',
  '#f97316',
  '#8b5cf6',
  '#ec4899',
  '#14b8a6',
  '#f59e0b',
  '#6366f1',
  '#64748b'
];
